// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles-module--h2--2YJn8","number":"styles-module--number--3YPaP"};